import type { ThemeConfig } from 'antd';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#bf5512',
    colorLink: '#0d5caa',
    colorLinkActive: '#0d5caa',
    colorLinkHover: '#0d5caa',
    controlHeight: 32,
    colorSplit: 'rgba(0, 0, 0, 0.85)',
    colorInfoBorder: 'rgb(145, 213, 255)',
    colorInfoBg: 'rgb(230, 247, 255)',
  },
  components: {
    Button: {
      defaultColor: '#bf5512',
      defaultBorderColor: '#bf5512',
    },
  },
};
